import { Path, Svg } from '@react-pdf/renderer';

export function Logo() {
  return (
    <Svg width="97" height="32" viewBox="0 0 97 32">
      <Path
        d="M85.7679 32C78.7501 32 74.2329 27.0391 74.2329 20.707C74.2329 14.3749 79.1534 9.33334 85.6469 9.33334C92.1807 9.33334 96.8995 14.0522 96.8995 20.5053V22.6026H79.5971C80.3231 25.4258 82.622 27.2005 85.8485 27.2005C87.9173 27.2005 89.442 26.4751 90.5265 25.2735C91.6331 25.9753 93.5649 27.2005 94.9371 28.0707C92.827 30.4933 89.9585 32 85.7679 32ZM85.6469 14.0522C82.8236 14.0522 80.6457 15.7058 79.7584 18.2467H91.374C90.6481 15.5445 88.5508 14.0522 85.6469 14.0522Z"
        fill="#4532AD"
      />
      <Path
        d="M67.9684 31.3333L61.8216 22.3718L58.487 26.1091V31.3333H52.9829V0H58.487V19.7195L67.2855 9.63281H73.9144L65.7588 18.8756L74.3162 31.3333H67.9684Z"
        fill="#4532AD"
      />
      <Path
        d="M38.6303 32C31.632 32 27.9829 27.5732 27.9829 20.1818V9.66666H33.8081V20.3037C33.8081 23.9588 35.1514 26.4767 38.6303 26.4767C42.1092 26.4767 42.8244 23.9588 42.8244 20.3037V9.66666H48.6495V20.1818C48.6495 27.5732 45.6286 32 38.6303 32Z"
        fill="#4532AD"
      />
      <Path
        fillRule="evenodd"
        d="M23.1273 20.356C23.13 20.4591 23.1314 20.5625 23.1314 20.6663C23.1314 26.918 18.1704 32 11.5961 32C5.06206 32 0.101074 26.918 0.101074 20.6663C0.101074 14.3743 5.06206 9.33267 11.5961 9.33267C13.8536 9.33267 15.9356 9.94202 17.6914 11.0014V0H23.1314V20.3541C23.1314 20.3541 23.13 20.3548 23.1273 20.356ZM17.6057 20.626C17.6057 24.014 14.9437 26.7163 11.6364 26.7163C8.28873 26.7163 5.66706 24.014 5.66706 20.626C5.66706 17.238 8.28873 14.5357 11.6364 14.5357C14.9437 14.5357 17.6057 17.238 17.6057 20.626Z"
        fill="#4532AD"
      />
    </Svg>
  );
}
